import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {cIOMAPPEDFREQUENCY, FrequencyStatus} from "../../frequency/frequencyStatus";
import {interval, Subscription} from "rxjs";
import {FrequencydetailsComponent} from "../../frequency/frequencydetails/frequencydetails.component";
import {FrequencyStatusDataservice} from "../../frequency/frequency-status-dataservice";
import {CounterStatusDataservice} from "../counter-status-dataservice";
import {cIOMAPPEDCOUNTER, CounterStatus} from "../counterStatus";
import {CounterdetailsComponent} from "../counterdetails/counterdetails.component";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-counterlist',
  templateUrl: './counterlist.component.html',
  styleUrls: ['./counterlist.component.css']
})
export class CounterlistComponent implements OnInit, OnDestroy{
  cntStatus: CounterStatus | undefined;
  private updateSubscription: Subscription | undefined;
  errorMessage: string = "";
  componentList = Array<CounterdetailsComponent>();
  public loaderStatus: number = 0;


  counter(i: number) {
    return new Array(i);
  }

  constructor(private counterStatusDataservice: CounterStatusDataservice)                {  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.counterStatusDataservice.GetData().subscribe(
      {
        next: cntStatus => {
          this.loaderStatus = 1;
          this.cntStatus = cntStatus;
          for(let detail of this.componentList) {
            detail.UpdateCntState(this.GetStatus(detail.refNumber));
          }
          this.ReSubscribe();
        }, error: err => this.errorMessage = err
      });
  }

  ngOnInit(): void {
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  Add(counterdetailsComponent: CounterdetailsComponent): void
  {
    this.componentList.push(counterdetailsComponent);
  }

  GetStatus(refNumber: number): cIOMAPPEDCOUNTER {
    if( ( this.cntStatus) && (this.cntStatus.cIO_MAPPED_COUNTER[refNumber]))
      return this.cntStatus.cIO_MAPPED_COUNTER[refNumber];
    return new cIOMAPPEDCOUNTER();
  }



}
